import React, { useState } from 'react';
import { Box } from '@mui/material';
import { WorkspaceInvestigationProps, InvestigationStatus } from './types';
import { NextBestAction } from './NextBestAction';
import { ApprovedPlanChecklist } from './ApprovedPlanChecklist';
import { PriorityQuestionsPanel } from './PriorityQuestionsPanel';
import { ScheduleInterviewModal } from './ScheduleInterviewModal';

export const WorkspaceInvestigation: React.FC<WorkspaceInvestigationProps> = ({
  caseId,
  plan,
  onChecklistUpdate,
}) => {
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);

  if (!plan || plan.status !== InvestigationStatus.ACCEPTED) {
    return null;
  }

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 3,
          alignItems: 'flex-start',
        }}
      >
        <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 66.666%' }, minWidth: 0 }}>
          {plan.nextBestAction && (
            <NextBestAction
              plan={plan}
              onActionClick={() => {
                if (plan.nextBestAction?.actionType === 'schedule') {
                  setScheduleModalOpen(true);
                }
              }}
            />
          )}
          <ApprovedPlanChecklist
            plan={plan}
            onChecklistUpdate={onChecklistUpdate}
          />
        </Box>

        <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 33.333%' }, minWidth: 0 }}>
          <PriorityQuestionsPanel plan={plan} />
        </Box>
      </Box>

      {plan.scheduling && (
        <ScheduleInterviewModal
          open={scheduleModalOpen}
          caseId={caseId}
          caseDisplayId={plan.caseDisplayId}
          scheduling={plan.scheduling}
          onClose={() => setScheduleModalOpen(false)}
          onSendInvitations={() => setScheduleModalOpen(false)}
        />
      )}
    </Box>
  );
};
